import { memo } from 'react';
import { MediaFileProps } from '../media-file.types';

export const Image = memo(
  ({ file, view }: Pick<MediaFileProps, 'file' | 'view'>) => {
    return (
      <img src={file.src} alt={file.alt ?? ''} style={{ objectFit: view }} />
    );
  }
);
